 const EligibilityData = [
    {value: 'Eligibility Unavailable',displayVal:'Eligibility Unavailable'},
    {value: 'Active Coverage',displayVal:'Active Coverage'},
    {value: 'Check Pending',displayVal:'Check Pending'},
    {value: 'Insurance Pending',displayVal:'Insurance Pending'},
    {value: 'Image Uploaded',displayVal:'Image Uploaded'},
    {value: 'Invalid/Missing Subscriber/Insured Name - Ple',displayVal:'Invalid/Missing Subscriber/Insured Name - Ple'},
]

export default EligibilityData;